import { useTranslation } from 'react-i18next';

export default function SuccessSection() {
  const { t } = useTranslation();

  const stories = [
    {
      icon: 'ri-search-line',
      title: t('success.auditing'),
      description: t('success.auditing.desc')
    },
    {
      icon: 'ri-bank-line',
      title: t('success.financial'),
      description: t('success.financial.desc')
    },
    {
      icon: 'ri-government-line',
      title: t('success.municipality'),
      description: t('success.municipality.desc')
    }
  ];

  return (
    <section 
      className="py-20 bg-slate-900 text-white relative"
      style={{
        backgroundImage: `linear-gradient(rgba(15, 23, 42, 0.9), rgba(15, 23, 42, 0.9)), url('https://readdy.ai/api/search-image?query=Professional%20business%20success%20stories%20background%20with%20corporate%20buildings%20and%20technology%20elements%2C%20modern%20office%20environment%20with%20digital%20transformation%20theme%2C%20dark%20blue%20and%20teal%20color%20scheme%2C%20professional%20lighting%20and%20atmosphere&width=1920&height=800&seq=success-bg&orientation=landscape')`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat'
      }}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold mb-4">
            {t('success.title')}
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {stories.map((story, index) => (
            <div key={index} className="bg-white/10 backdrop-blur-sm rounded-xl p-8 hover:bg-white/20 transition-colors">
              <div className="w-16 h-16 bg-blue-600 rounded-full flex items-center justify-center mb-6">
                <i className={`${story.icon} text-2xl text-white`}></i>
              </div>
              <h3 className="text-xl font-bold mb-4">{story.title}</h3>
              <p className="text-gray-300 leading-relaxed">{story.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}